var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSubGrafica)?_c('router-link',{staticClass:"sub-grafica",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }